import * as managerDetailsActions from '@manager-details/actions/manager-details.actions';
import { ManagerDetailsArray } from '@manager-details/models/manager-details';

export interface State {
  managerDetails: ManagerDetailsArray,
  loading: boolean,
}

export const INITIAL_STATE: State = {
  managerDetails: undefined,
  loading: false,
}

export function reducer(state: State = INITIAL_STATE, action: managerDetailsActions.Actions): State {
  switch (action.type) {
    case managerDetailsActions.GET:
      {
        return { ...state, managerDetails: undefined, loading: true };
      }
    case managerDetailsActions.GET_COMPLETE:
      {
        return { ...state, managerDetails: action.payload, loading: false };
      }
    default:
      {
        return state;
      }
  }
}
